import { MainTableFilterModel } from 'src/app/shared/models/main-table-filter.model';

export class LoadMessages {
  static readonly type = '[Messages] Load Messages';

  constructor(public filter?: MainTableFilterModel) {}
}
